import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

   //exiting code
    // const expectedRoles: string[] = next.data['expectedRoles'];

    // if (this.authService.isAuthenticated() && this.checkRoles(expectedRoles)) {
    //   return true;
    // }
    
    //new code
    if (this.authService.isAuthenticated()) {
      return true;
    }
    
    // Redirect to the login page with return url, if not authenticated or lacking required roles
    this.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
    if(state.url){
      this.authService.updateReturnURL(state.url);
    }
    return false;
  }

  // private checkRoles(expectedRoles: string[]): boolean {
  //   const userRoles = this.authService.getUserRoles();

  //   // Check if the user has any of the expected roles
  //   return expectedRoles.some(role => userRoles.includes(role));
  // }
}
